<template>
  <div style="height: 100%;overflow: auto;" v-loading="isLoading">
    <div class="operate-guide">
      <el-date-picker
        v-model="date"
        type="daterange"
        align="right"
        unlink-panels
        size="mini"
        class="search-item"
        range-separator="至"
        value-format="yyyy-MM-dd"
        start-placeholder="开始日期"
        end-placeholder="结束日期">
      </el-date-picker>
      <el-select
        v-model="site"
        multiple
        collapse-tags
        size="mini"
        class="input-item search-item"
        clear
        placeholder="站点">
        <el-option
          v-for="item in allSite"
          :key="item.id"
          :label="item.name"
          :value="item.code">
        </el-option>
      </el-select>
      <el-input
        placeholder="名称和文件内容"
        size="mini"
        class="input-item search-item"
        v-model="name">
      </el-input>
      <el-button @click="search" size="mini" type="primary">搜索</el-button>
    </div>
    <div class="record-list">
      <ul>
        <li v-for="record in recordFiles">
          <a :href="record.url">
            {{ record.name }}
            &nbsp;{{ record.size }} bytes
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import util from '@/libs/util'

  export default {
    name: 'operate-record-manage',
    data() {
      return {
        date: null,
        site: [],
        name: null,
        isLoading: false,
        allSite: {},
        recordFiles: []
      }
    },
    created() {
      this.load()
    },
    methods: {
      load: function() {
        util.ajax.post('/superAdmin/permissionManage/getAllWebSites').then(res => {
          if (res.data.meta.errCode === 0) {
            this.allSite = res.data.data
          } else {
            this.$message.info('获取站点数据失败：' + res.data.meta.errMsg)
          }
        }).catch(err => {
          console.error(err)
          this.$message.error('系统错误')
        })
      },
      search: function() {
        let params = {
          name: this.name,
          date: this.date,
          site: this.site
        }
        this.isLoading = true
        util.ajax.post('/entity/superAdmin/operateRecordManage/listFile', {
          params: params
        }).then(res => {
          if (res.data.meta.errCode === 0) {
            this.recordFiles = res.data.data
          } else {
            this.$message.info(res.data.meta.errMsg)
          }
          this.isLoading = false
        }).catch(err => {
          console.error(err)
          this.$message.error('系统错误')
          this.isLoading = false
        })
      }
    }
  }
</script>

<style scoped>
  .input-item {
    width: 200px;
  }

  .search-item {
    margin: 10px;
  }

  .operate-guide {
    padding: 10px;
  }

  .record-list {
    width: 80%;
    border-top: 1px solid #d0cbcb;
    margin: 10px;
  }

  ul {
    padding: 20px;
  }

  li {
    padding: 5px;
  }

  li a {
    color: #4a9bd7;
    text-decoration: none;
  }

  li a:hover {
    color: #194ad7;
  }
</style>



// WEBPACK FOOTER //
// src/components/record/operate-record-manage.vue